import { Box } from '@mui/material';
import { useCallback } from 'react';
import { Header, LWModal, Page, Toolbox } from 'redesign';
import {
  AccreditationParams,
  ACCREDITATIONS_INITIAL_VALUES,
  SetAccreditationParams,
} from './accreditations.types';
import { useGetCertificateNames } from './hooks/use-get-certificates-names';
import { AccreditationDetail } from './detail/accreditations-detail';
import { AccreditationsToolbox } from './toolbox/accreditations-toolbox';
import { AccreditationsTableProvider } from './accreditations-table-provider';
import { useExternalParams } from '../../../../shared/hooks';
import { RenderUnsettledUI } from '../../../../shared/components';
import { HQCertificateWithFileUrl } from '../../../services/accreditations-service.types';

export const Accreditations = () => {
  const [params, setParams] = useExternalParams(ACCREDITATIONS_INITIAL_VALUES);

  const certificatesQuery = useGetCertificateNames();

  if (certificatesQuery.status !== 'success') {
    return <RenderUnsettledUI data={certificatesQuery} />;
  }

  return (
    <AccreditationsImpl
      certificateData={certificatesQuery.data}
      params={params as AccreditationParams}
      setParams={setParams}
    />
  );
};

const AccreditationsImpl = ({
  certificateData,
  params,
  setParams,
}: {
  certificateData: HQCertificateWithFileUrl[];
  params: AccreditationParams;
  setParams: SetAccreditationParams;
}) => {
  const closeDetail = useCallback(() => setParams({ flexWorkerId: undefined }), []);

  return (
    <>
      <Page
        header={<Header titleText="Verificatie status" />}
        toolbox={
          <Toolbox alignCenter={true}>
            <AccreditationsToolbox
              certificateData={certificateData}
              params={params}
              setParams={setParams}
            ></AccreditationsToolbox>
          </Toolbox>
        }
      >
        <Box width="100%">
          <AccreditationsTableProvider params={params} setParams={setParams} />
        </Box>
      </Page>
      <LWModal isOpen={!!params.flexWorkerId} onClose={closeDetail}>
        {params.flexWorkerId && params.certificateId && params.accreditationType ? (
          <AccreditationDetail
            accreditationType={params.accreditationType}
            flexWorkerId={params.flexWorkerId}
            certificateId={params.certificateId}
            close={closeDetail}
          />
        ) : null}
      </LWModal>
    </>
  );
};
